export default __webpack_public_path__ + "img/d9228a2a151003523068ef08f0adba5a.png";